import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import URLS from 'redux/urls'
import request from 'redux/utils/request'

export const fetchAllAttendance = createAsyncThunk(
    'Attendance/fetchAllAttendance',
    async (_,{ rejectWithValue }) => {
        try {
            const response = await request('get', URLS.ATTENDANCE)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const fetchAllByTanggalFilter = createAsyncThunk(
    'Attendance/fetchAllByTanggalFilter',
    async (params, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.ATTENDANCE}/tanggal-range?startDate=${params.startDate}&endDate=${params.endDate}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const fetchByScheduleId = createAsyncThunk(
    'Attendance/fetchByScheduleId',
    async (schedule_id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.ATTENDANCE}?schedule_id=${schedule_id}`)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const addAttendance = createAsyncThunk(
    'Attendance/addAttendance',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('post', URLS.ATTENDANCE, payload)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const updateAttendance = createAsyncThunk(
    'Attendance/updateAttendance',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('put', URLS.ATTENDANCE, payload)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const fetchOneAttendance = createAsyncThunk(
    'Attendance/fetchOneAttendance',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.ATTENDANCE}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const deleteAttendance = createAsyncThunk(
    'Attendance/deleteAttendance',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('delete', `${URLS.ATTENDANCE}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const initialState = {
    loading: {
        query: false,
        mutation: false
    },
    filter: {
        q: ''
    },
    list: [],
    count: {},
    selected: {},
    selectedRows: []
}

const loadingReducer = (fieldName, status) => (state) => {
    state.loading[fieldName] = status
}

const startLoadingQuery = loadingReducer('query', true)
const stopLoadingQuery = loadingReducer('query', false)
const startLoadingMutation = loadingReducer('mutation', true)
const stopLoadingMutation = loadingReducer('mutation', false)

export const AttendanceSlice = createSlice({
    name: 'Attendance',
    initialState,
    reducers: {
        setAppliedSearchText: (state, action) => {
            state.filter.q = action.payload
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllAttendance.pending, startLoadingQuery)
            .addCase(fetchAllAttendance.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllAttendance.rejected, stopLoadingQuery)
        builder
            .addCase(fetchAllByTanggalFilter.pending, startLoadingQuery)
            .addCase(fetchAllByTanggalFilter.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllByTanggalFilter.rejected, stopLoadingQuery)
        builder
            .addCase(fetchOneAttendance.pending, startLoadingQuery)
            .addCase(fetchOneAttendance.rejected, stopLoadingQuery)
            .addCase(fetchOneAttendance.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(updateAttendance.pending, startLoadingQuery)
            .addCase(updateAttendance.rejected, stopLoadingQuery)
            .addCase(updateAttendance.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(fetchByScheduleId.pending, startLoadingQuery)
            .addCase(fetchByScheduleId.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchByScheduleId.rejected, stopLoadingQuery)
        builder
            .addCase(deleteAttendance.pending, startLoadingMutation)
            .addCase(deleteAttendance.fulfilled, stopLoadingMutation)
            .addCase(deleteAttendance.rejected, stopLoadingMutation)
    }
});


export const { setSelectedRows, setAppliedSearchText } = AttendanceSlice.actions;

export default AttendanceSlice.reducer;